import React from "react";
import { Link } from "react-router-dom";
import { Mail, Shield, Lock, MapPin } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="mt-auto bg-primary text-primary-foreground" data-testid="main-footer">
      <div className="container grid gap-10 py-16 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo light />
          <p className="mt-5 max-w-md text-sm leading-relaxed text-white/70">
            Recovery Leaders is a trust-first platform helping investment scam victims understand
            what happened, explore realistic recovery options, and take informed next steps — with
            empathy, honesty, and no upfront fees.
          </p>
          <a
            href="mailto:support@recovery-leaders.com"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-white/90 hover:text-accent"
            data-testid="footer-email"
          >
            <Mail className="h-4 w-4" /> support@recovery-leaders.com
          </a>

          <div className="mt-6 grid gap-5 sm:grid-cols-2" data-testid="footer-offices">
            <div className="flex items-start gap-2.5">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-accent" />
              <div>
                <p className="text-xs font-bold uppercase tracking-widest text-white/90">London Office</p>
                <p className="mt-1 text-sm leading-relaxed text-white/60">
                  1 Canada Square, Canary Wharf<br />London E14 5AB, United Kingdom
                </p>
              </div>
            </div>
            <div className="flex items-start gap-2.5">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-accent" />
              <div>
                <p className="text-xs font-bold uppercase tracking-widest text-white/90">Toronto Office</p>
                <p className="mt-1 text-sm leading-relaxed text-white/60">
                  100 King Street West, Suite 5600<br />Toronto, ON M5X 1C9, Canada
                </p>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h4 className="mb-4 font-display text-lg">Explore</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/how-it-works" className="hover:text-accent">How It Works</Link></li>
            <li><Link to="/insights" className="hover:text-accent">Scam Types & Insights</Link></li>
            <li><Link to="/contact" className="hover:text-accent">Contact Us</Link></li>
            <li><Link to="/private-file" className="inline-flex items-center gap-1.5 hover:text-accent"><Lock className="h-3.5 w-3.5" /> Private File</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-display text-lg">Trust & Legal</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/privacy" className="hover:text-accent">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-accent">Terms of Service</Link></li>
          </ul>
          <div className="mt-5 flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-white/60">
            <Shield className="h-4 w-4 text-accent" /> Secure & Confidential
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container flex flex-col items-center justify-between gap-3 py-6 text-xs text-white/50 sm:flex-row">
          <p>© {new Date().getFullYear()} Recovery Leaders. All rights reserved.</p>
          <p>No guarantee of recovery. Not a substitute for legal or financial advice.</p>
        </div>
      </div>
    </footer>
  );
}
